import React from 'react';

import CategorySelect from '../../generic/CategorySelect';
import MultiSelect from '../../generic/MultiSelect';
import Thumbnail from '../../generic/Thumbnail';
import {
  COUNTRIES_NOT_FOUND,
  GENDERS_NOT_FOUND,
  MEDIA_TYPES,
} from '../../generic/Thumbnail/constants';

const getInputId = (row, accessor) => {
  return `${row.original.contentIdIndex}.${accessor}`;
};

const getCommonSelectProps = (accessor, width) => ({
  styles: {
    input: base => ({ ...base, width }),
    menuPortal: base => ({ ...base, zIndex: 1051 }),
  },
  className: `m-select--small qa-field-${accessor}`,
  // Override select styles to make it display correctly while shown
  // from within a modal: https://react-select.com/advanced#portaling
  menuPortalTarget: document.body,
});

export const selectContentId = (onSelection, selectedCreatives) => ({
  Header: '',
  key: 'select',
  accessor: 'contentId',
  Cell: row => (
    <input
      type="checkbox"
      checked={selectedCreatives.includes(row.value)}
      onChange={onSelection.bind(null, row.value)} // eslint-disable-line react/jsx-no-bind
    />
  ),
  width: 25,
  filterable: false,
});

export const contentEntryNameColumn = {
  Header: 'Content Entry Name',
  accessor: 'contentName',
  width: 280,
  className: 'text-wrap',
};

export const contentIdColumn = {
  Header: 'Content ID',
  accessor: 'contentId',
  width: 280,
  className: 'text-wrap',
};

export const productTagsColumn = (onChange, productTagsOptions) => {
  const accessor = 'productTags';
  return {
    Header: 'Product Tags',
    accessor,
    width: 140,
    Cell: row => (
      <MultiSelect
        isSearchable={false}
        {...getCommonSelectProps(accessor, 80)}
        options={productTagsOptions}
        name={getInputId(row, accessor)}
        value={row.value}
        onChange={onChange}
        id={getInputId(row, accessor)}
      />
    ),
    className: 'text-wrap',
  };
};

export const gendersColumn = {
  Header: 'Genders',
  accessor: 'genders',
  Cell: row => row.value?.join(', ') || GENDERS_NOT_FOUND,
  width: 125,
  className: 'text-wrap',
};

export const countryCodesColumn = {
  Header: 'Countries',
  accessor: 'countryCodes',
  Cell: row => row.value?.join(', ') || COUNTRIES_NOT_FOUND,
  width: 125,
  className: 'text-wrap',
};

export const thumbnail = {
  Header: 'Creative',
  accessor: 'imageUrl',
  Cell: row => {
    const id = 'contentful-creatives-list';
    return (
      <Thumbnail
        id={id}
        key={id}
        alt={row.value}
        src={row.value}
        previewSrc={row.value}
        type={MEDIA_TYPES.IMAGE}
      />
    );
  },
  width: 91,
  filterable: false,
  sortable: false,
};

export function productIdsColumn(onChange, getSupportedProductCodes) {
  const accessor = 'productIds';
  return {
    Header: 'Products',
    accessor,
    width: 125,
    Cell: row => {
      const supportedProducts = getSupportedProductCodes(row.original);
      const options = supportedProducts.map(p => ({
        label: p.label,
        value: p.value,
      }));
      return (
        <MultiSelect
          isSearchable={false}
          {...getCommonSelectProps(accessor, 80)}
          options={options}
          name={`${row.index}.productIds`}
          value={row.original.productIds}
          onChange={onChange}
          id={getInputId(row, accessor)}
        />
      );
    },
    className: 'text-wrap',
  };
}

export const categoriesColumn = onChange => {
  const accessor = 'categories';
  return {
    Header: 'Categories',
    accessor,
    width: 165,
    Cell: row => (
      <CategorySelect
        {...getCommonSelectProps(accessor, 80)}
        name={getInputId(row, accessor)}
        value={row.value}
        onChange={onChange}
        id={getInputId(row, accessor)}
        defaultValue={[]}
        filteredValues={row.original.compatibleCategories}
      />
    ),
    className: 'text-wrap',
  };
};
